import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { AlertController } from '@ionic/angular';

@Injectable()
export class AutoLoginGuard {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertController: AlertController
  ) {}

  async canActivate() {
    const user = this.authenticationService.userValue;

    if (!user) {
      // authorised so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/orders']);
    return false;
  }
}
